<template>
  <div class="dashboard-container">
    <!-- 欢迎标题 -->
    <div class="welcome-banner">
      <div class="welcome-content">
        <div class="welcome-text">
          <h1 class="welcome-title">
            <span class="greeting">{{ greeting }}，</span>
            <span class="username">{{ userName }}</span>
            <span class="wave">👋</span>
          </h1>
          <p class="welcome-subtitle">欢迎使用送呗Songbay管理系统，今天也要元气满满哦！</p>
        </div>
        <div class="welcome-icon">
          <img src="../../assets/logo.jpg" alt="Logo">
        </div>
      </div>
    </div>

    <!-- 数据统计卡片 -->
    <el-row :gutter="24" class="stats-row">
      <el-col :xs="24" :sm="12" :md="6" v-for="(stat, index) in stats" :key="index">
        <div class="stat-card" :style="{ '--card-color': stat.color }">
          <div class="stat-icon" :style="{ background: stat.background }">
            <i :class="stat.icon"></i>
          </div>
          <div class="stat-content">
            <div class="stat-label">{{ stat.label }}</div>
            <div class="stat-value">{{ stat.value }}</div>
            <div class="stat-trend" :class="stat.trend > 0 ? 'up' : 'down'">
              <i :class="stat.trend > 0 ? 'el-icon-top' : 'el-icon-bottom'"></i>
              <span>{{ Math.abs(stat.trend) }}% 较上周</span>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>

    <!-- 快捷功能和图表区域 -->
    <el-row :gutter="24" class="content-row">
      <!-- 快捷功能 -->
      <el-col :xs="24" :md="12" :lg="8">
        <el-card class="quick-actions-card">
          <div slot="header" class="card-header">
            <i class="el-icon-s-grid"></i>
            <span>快捷功能</span>
          </div>
          <div class="quick-actions">
            <div 
              class="action-item" 
              v-for="(action, index) in quickActions" 
              :key="index"
              @click="handleQuickAction(action.path)"
            >
              <div class="action-icon" :style="{ background: action.background }">
                <i :class="action.icon"></i>
              </div>
              <div class="action-text">{{ action.label }}</div>
            </div>
          </div>
        </el-card>
      </el-col>

      <!-- 最近活动 -->
      <el-col :xs="24" :md="12" :lg="8">
        <el-card class="recent-activities-card">
          <div slot="header" class="card-header">
            <i class="el-icon-bell"></i>
            <span>最近活动</span>
          </div>
          <div class="activities-list">
            <div class="activity-item" v-for="(activity, index) in recentActivities" :key="index">
              <div class="activity-dot" :style="{ background: activity.color }"></div>
              <div class="activity-content">
                <div class="activity-title">{{ activity.title }}</div>
                <div class="activity-time">{{ activity.time }}</div>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>

      <!-- 系统信息 -->
      <el-col :xs="24" :md="24" :lg="8">
        <el-card class="system-info-card">
          <div slot="header" class="card-header">
            <i class="el-icon-info"></i>
            <span>系统信息</span>
          </div>
          <div class="system-info">
            <div class="info-item">
              <span class="info-label">系统版本</span>
              <span class="info-value">v2.0.0</span>
            </div>
            <div class="info-item">
              <span class="info-label">运行环境</span>
              <span class="info-value">Production</span>
            </div>
            <div class="info-item">
              <span class="info-label">服务器状态</span>
              <el-tag size="small" type="success">运行中</el-tag>
            </div>
            <div class="info-item">
              <span class="info-label">最后更新</span>
              <span class="info-value">2025-11-23</span>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 数据图表区域 -->
    <el-row :gutter="24" class="chart-row">
      <el-col :xs="24" :lg="16">
        <el-card class="chart-card">
          <div slot="header" class="card-header">
            <i class="el-icon-data-line"></i>
            <span>订单趋势</span>
          </div>
          <div class="chart-placeholder">
            <i class="el-icon-data-line"></i>
            <p>订单数据图表区域</p>
            <span class="tip">可集成 ECharts 显示数据趋势</span>
          </div>
        </el-card>
      </el-col>

      <el-col :xs="24" :lg="8">
        <el-card class="chart-card">
          <div slot="header" class="card-header">
            <i class="el-icon-pie-chart"></i>
            <span>业务占比</span>
          </div>
          <div class="chart-placeholder">
            <i class="el-icon-pie-chart"></i>
            <p>业务分布饼图</p>
            <span class="tip">可集成 ECharts 显示占比分析</span>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'Dashboard',
  data() {
    return {
      userName: '',
      stats: [
        {
          label: '今日订单',
          value: '328',
          trend: 12,
          icon: 'el-icon-s-order',
          color: '#00C2A8',
          background: 'linear-gradient(135deg, #00C2A8 0%, #00AB95 100%)'
        },
        {
          label: '总用户数',
          value: '2,458',
          trend: 8,
          icon: 'el-icon-user',
          color: '#1890ff',
          background: 'linear-gradient(135deg, #1890ff 0%, #096dd9 100%)'
        },
        {
          label: '今日营收',
          value: '¥18,560',
          trend: 15,
          icon: 'el-icon-money',
          color: '#faad14',
          background: 'linear-gradient(135deg, #faad14 0%, #d48806 100%)'
        },
        {
          label: '活跃商家',
          value: '156',
          trend: -3,
          icon: 'el-icon-s-shop',
          color: '#f5222d',
          background: 'linear-gradient(135deg, #ff7875 0%, #f5222d 100%)'
        }
      ],
      quickActions: [
        {
          label: '订单管理',
          icon: 'el-icon-s-order',
          path: '/sys_order',
          background: 'linear-gradient(135deg, rgba(0, 194, 168, 0.1), rgba(0, 194, 168, 0.2))'
        },
        {
          label: '用户管理',
          icon: 'el-icon-user',
          path: '/campus_user',
          background: 'linear-gradient(135deg, rgba(24, 144, 255, 0.1), rgba(24, 144, 255, 0.2))'
        },
        {
          label: '商品管理',
          icon: 'el-icon-goods',
          path: '/product',
          background: 'linear-gradient(135deg, rgba(250, 173, 20, 0.1), rgba(250, 173, 20, 0.2))'
        },
        {
          label: '店铺管理',
          icon: 'el-icon-s-shop',
          path: '/shop',
          background: 'linear-gradient(135deg, rgba(245, 34, 45, 0.1), rgba(245, 34, 45, 0.2))'
        },
        {
          label: '退款处理',
          icon: 'el-icon-sold-out',
          path: '/refund',
          background: 'linear-gradient(135deg, rgba(114, 46, 209, 0.1), rgba(114, 46, 209, 0.2))'
        },
        {
          label: '系统设置',
          icon: 'el-icon-setting',
          path: '/menu',
          background: 'linear-gradient(135deg, rgba(82, 196, 26, 0.1), rgba(82, 196, 26, 0.2))'
        }
      ],
      recentActivities: [
        {
          title: '新用户注册',
          time: '5分钟前',
          color: '#00C2A8'
        },
        {
          title: '新订单待处理',
          time: '15分钟前',
          color: '#1890ff'
        },
        {
          title: '商家申请审核',
          time: '1小时前',
          color: '#faad14'
        },
        {
          title: '系统更新完成',
          time: '2小时前',
          color: '#52c41a'
        },
        {
          title: '数据备份成功',
          time: '3小时前',
          color: '#722ed1'
        }
      ]
    };
  },
  computed: {
    greeting() {
      const hour = new Date().getHours();
      if (hour < 6) return '凌晨好';
      if (hour < 9) return '早上好';
      if (hour < 12) return '上午好';
      if (hour < 14) return '中午好';
      if (hour < 17) return '下午好';
      if (hour < 19) return '傍晚好';
      if (hour < 22) return '晚上好';
      return '夜深了';
    }
  },
  created() {
    this.getUser();
  },
  methods: {
    async getUser() {
      try {
        const { data: res } = await this.$http.get("user/getUserByToken", {
          params: {
            token: window.sessionStorage.getItem("token"),
          }
        });
        if (res.code === 200) {
          this.userName = res.data.userName;
        }
      } catch (error) {
        console.error('获取用户信息失败', error);
      }
    },
    handleQuickAction(path) {
      if (path) {
        this.$router.push(path);
      }
    }
  }
};
</script>

<style scoped>
.dashboard-container {
  max-width: 1600px;
  margin: 0 auto;
}

/* 欢迎横幅 */
.welcome-banner {
  background: linear-gradient(135deg, #00C2A8 0%, #00AB95 50%, #009582 100%);
  border-radius: 16px;
  padding: 32px 40px;
  margin-bottom: 24px;
  box-shadow: 0 8px 24px rgba(0, 194, 168, 0.25);
  position: relative;
  overflow: hidden;
}

.welcome-banner::before {
  content: '';
  position: absolute;
  width: 300px;
  height: 300px;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.15), transparent 70%);
  top: -100px;
  right: -100px;
  border-radius: 50%;
}

.welcome-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  z-index: 1;
}

.welcome-text {
  flex: 1;
}

.welcome-title {
  font-size: 32px;
  font-weight: 700;
  color: white;
  margin: 0 0 12px 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.greeting {
  color: rgba(255, 255, 255, 0.9);
}

.username {
  color: white;
}

.wave {
  display: inline-block;
  animation: wave 1s ease-in-out infinite;
  transform-origin: 70% 70%;
}

@keyframes wave {
  0%, 100% { transform: rotate(0deg); }
  25% { transform: rotate(20deg); }
  75% { transform: rotate(-20deg); }
}

.welcome-subtitle {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.95);
  margin: 0;
  font-weight: 500;
}

.welcome-icon {
  width: 80px;
  height: 80px;
  background: white;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
  overflow: hidden;
}

.welcome-icon img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 统计卡片 */
.stats-row {
  margin-bottom: 24px;
}

.stat-card {
  background: white;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  gap: 20px;
  align-items: center;
  cursor: pointer;
  border: 2px solid transparent;
  margin-bottom: 20px;
}

.stat-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 194, 168, 0.2);
  border-color: var(--card-color);
}

.stat-icon {
  width: 60px;
  height: 60px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  color: white;
  flex-shrink: 0;
}

.stat-content {
  flex: 1;
}

.stat-label {
  font-size: 14px;
  color: var(--text-secondary);
  margin-bottom: 8px;
  font-weight: 500;
}

.stat-value {
  font-size: 28px;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 4px;
}

.stat-trend {
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 4px;
}

.stat-trend.up {
  color: #52c41a;
}

.stat-trend.down {
  color: #ff4d4f;
}

.stat-trend i {
  font-size: 14px;
  font-weight: bold;
}

/* 内容区域 */
.content-row {
  margin-bottom: 24px;
}

.card-header {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  color: var(--text-primary);
  font-size: 16px;
}

.card-header i {
  color: var(--primary-color);
  font-size: 18px;
}

/* 快捷功能 */
.quick-actions-card {
  height: 100%;
}

.quick-actions {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.action-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 20px 16px;
  border-radius: 12px;
  border: 2px solid #f0f0f0;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.action-item:hover {
  transform: translateY(-4px);
  border-color: var(--primary-color);
  box-shadow: 0 8px 16px rgba(0, 194, 168, 0.15);
}

.action-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: var(--primary-color);
}

.action-text {
  font-size: 14px;
  font-weight: 500;
  color: var(--text-primary);
}

/* 最近活动 */
.recent-activities-card {
  height: 100%;
}

.activities-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.activity-item {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  padding: 12px;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.activity-item:hover {
  background: var(--bg-hover);
}

.activity-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-top: 6px;
  flex-shrink: 0;
}

.activity-content {
  flex: 1;
}

.activity-title {
  font-size: 14px;
  color: var(--text-primary);
  font-weight: 500;
  margin-bottom: 4px;
}

.activity-time {
  font-size: 12px;
  color: var(--text-secondary);
}

/* 系统信息 */
.system-info-card {
  height: 100%;
}

.system-info {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.info-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #f0f0f0;
}

.info-item:last-child {
  border-bottom: none;
}

.info-label {
  font-size: 14px;
  color: var(--text-secondary);
  font-weight: 500;
}

.info-value {
  font-size: 14px;
  color: var(--text-primary);
  font-weight: 600;
}

/* 图表区域 */
.chart-row {
  margin-bottom: 24px;
}

.chart-card {
  height: 100%;
  min-height: 300px;
}

.chart-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 250px;
  color: var(--text-secondary);
}

.chart-placeholder i {
  font-size: 64px;
  color: var(--border-color);
  margin-bottom: 16px;
}

.chart-placeholder p {
  font-size: 16px;
  margin: 0 0 8px 0;
  font-weight: 500;
}

.chart-placeholder .tip {
  font-size: 13px;
  color: var(--text-disabled);
}

/* 响应式 */
@media (max-width: 768px) {
  .welcome-banner {
    padding: 24px 20px;
  }

  .welcome-title {
    font-size: 24px;
    flex-wrap: wrap;
  }

  .welcome-subtitle {
    font-size: 14px;
  }

  .welcome-icon {
    width: 60px;
    height: 60px;
  }

  .stat-card {
    padding: 20px;
  }

  .stat-value {
    font-size: 24px;
  }

  .quick-actions {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>

